import { render } from "./Rules.vue?vue&type=template&id=bb0a19e4"
import script from "./Rules.vue?vue&type=script&lang=js"
export * from "./Rules.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Solstice-Web/Solstice-Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__